import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';

const states: Ng1StateDeclaration[] = [
    {
        name: 'user',
        url: '/user/:userName',
        component: 'wtUserState',
        resolve: {
            auth: Resolve.authResolve,
            user: Resolve.superAdminOrUserResolve('userName')
        },
        data: {
            visible: false,
            isAuthenticated: true,
            isConnected: false,
            icon: 'fa-users',
            displayName: 'Users',
            editButtonVisibility: () => true,
            breadcrumbs: {
                level3StateName: 'users',
                level4: ''
            }
        }
    }];

export default states;